<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Shipping Line</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                class="mr-1"
                size="sm"
                variant="warning"
                v-if="showMain == false"
                @click="goToMain"
                >New ShippingLine</b-button
              >
              <b-button
                size="sm"
                class="ml-3"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="getReports('All_ShppingLine_Report')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div v-if="showMain == true">
          <b-card>
            <md-layout md-gutter>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Shipping Line Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="shippingLine"
                    name="shippingLine"
                    v-model="shipLine.shippingLine"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!shipLine.shippingLine">{{
                  shippingLineError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>GST No</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="gstNo"
                    name="gstNo"
                    v-model="shipLine.gstNo"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>PAN No</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="panNo"
                    name="panNo"
                    v-model="shipLine.panNo"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
              </md-layout>
            </md-layout>
            <md-layout md-gutter >
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Contact Person Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="contactPerson"
                    name="contactPerson"
                    v-model="shipLine.contactPerson"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Contact No</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="contactNo"
                    name="contactNo"
                    v-model="shipLine.contactNo"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Email-Id</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="email"
                    max="500"
                    name="email"
                    v-model="shipLine.email"
                  ></b-form-input>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
              </md-layout>
            </md-layout>

             <md-layout md-gutter>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>OI code</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="contactPerson"
                    name="contactPerson"
                    v-model="shipLine.oicode"
                  ></b-form-input>
                </md-layout>
              </md-layout>
             <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="65">
                <md-layout md-flex="100">
                  <label>Shipping Line Address</label>
                  <b-form-textarea :formatter="capitalizeAll"
                    id="address"
                    name="address"
                    v-model="shipLine.address"
                  ></b-form-textarea>
                </md-layout>
                <!-- <span class="error" v-if="!shippingLine">{{shippingLineError}}</span> -->
            </md-layout>
          </md-layout>

            <md-layout md-gutter class="mt-4">
              <md-layout class="justify-content-center">
                <b-button
                  variant="primary"
                  @click="addVehicleSize"
                  id="addButtonLoader"
                  >{{ shipLine.shippingId == "" ? "Add" : "Update" }}</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card>
        </div>
        <div class="mt-2">
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <!-- User Interface controls -->
        <div class="mt-2">
          <b-form-group>
            <b-input-group>
              <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type To Search" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="shippingDetails"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="shippingId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="shippingLine" slot-scope="row11">
              <div class="showMoreData" @click="editData(row11.item)">
                <b>
                  <span>{{ row11.item.shippingLine }}</span>
                </b>
                <br />
                <span>GST No. : {{ row11.item.gstNo }}</span>
                <br />
                <span>PAN No. : {{ row11.item.panNo }}</span>
                <br />
                <span>OI code. : {{ row11.item.oicode }}</span>
              </div>
            </template>
            <template slot="address" slot-scope="row1">
              <span>S-Line Address : {{ row1.item.address }}</span>
              <br />

              <span>Contact Person Name : {{ row1.item.contactPerson }}</span>
              <br />
              <span>Contact No. : {{ row1.item.contactNo }}</span>
              <br />
              <span>Email-Address : {{ row1.item.email }}</span>
            </template>
            <template slot="isShippingActive" slot-scope="row11">
              <b-button
                @click="addBranch(row11.item.shippingId)"
                size="sm"
                variant="outline-primary"
                >Add / Update Branch</b-button
              ><br /><br />
              <b-button
                @click="deleteData(row11.item.shippingId)"
                size="sm"
                variant="outline-danger"
                >Delete Sline</b-button
              ><br />
            </template>
          </b-table>
        </div>

        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop3"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/yard/shipping");
      this.truckSize();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "shippingId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shippingLine",
          label: "Shipping Line ",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "address",
          label: "Contact Detail",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isShippingActive",
          label: "",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "loginTime",
        //   label: "Creation Date",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        // {
        //   key: "show_details",
        //   mainkey: "departmentName1",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        // {
        //   key: "userId",
        //   label: "Status",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: "",
      showMain: false,
      shipLine: {
        shippingId: "",
        shippingLine: "",
        gstNo: "",
        panNo: "",
        contactPerson: "",
        contactNo: "",
        email: "",
        address: "",
        oicode:""
      },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      deleteId: "",
      shippingLine: "",
      vehicleSizeMaster: [{}],
      shippingDetails: [],
      validate: true,
      shippingLineError: "",
      excelUpload: "",
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading,
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.showMain = true;
    },
    JqueryFun() {
      return $(function () {
        return $("#shipping").DataTable();
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.shipLine.shippingLine == "") {
        $("#shippingLine").focus();
        this.shippingLineError = "Enter Shipping Line Name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addBranch(SHIP) {
      this.$sessionsStorage.set("branchShipId", SHIP);
      this.$router.push({
        path: "/yard/newShippingBranch",
      });
    },
    editData(item) {
      this.showMain = true;

      Object.keys(this.shipLine).map((x) => {
        this.shipLine[x] = item[x] || "";
      });
    },

    addVehicleSize() {
      this.validateAddVehicleSizeForm();
      //      let new_Size_Data={

      // shippingLine:this.shippingLine
      // }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/shippingLineMaster.php`,
          data: JSON.stringify(this.shipLine),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            console.log(result.data);
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.shipLine.shippingId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              this.$refs["addPop"].open();

              this.truckSize();
              Object.keys(this.shipLine).map((x) => {
                this.shipLine[x] = "";
              });
              this.shippingLineError = "";
              this.showMain = false;

              this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },

    truckSize() {
      this.isLoading = true;
      let type_Size = {
        truckSize: "truckSize",
        type: "Normal",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/shippingLineDetails.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.shippingDetails = data.truckSizeDetails;
            this.totalRows = data.truckSizeDetails.length;
            console.log("fsf", data.truckSizeDetails);
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "VehicleSizeMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vehicleSizeMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.truckSize();
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content =
        "Are you sure you want to delete this Shipping Line?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "shippinglinemaster",
          tableId: "shippingId",
          tableIsActive: "isShippingActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.JqueryFun();
              this.truckSize();
              console.log(data);
            }
          })
          .catch((error) => {});
      }
    },
    getReports(id) {
      let payload = {
        truckSize: id,
        type: "Excel",
      };
      this.ExcelBtnName = "Downloading Please Wait .....";
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Yard/shippingLineDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// shippingLineMaster.vue?6b7a75cd